import React, { FC, useCallback, useState } from 'react';
import { Stack, StackProps } from '@mui/material';
import { IconButton } from 'components/Buttons';
import Typography from 'components/Typography/Typography';
import { IntlShape } from 'react-intl';

import { ProjectsCountLabel } from './ProjectsCountLabel';
import * as styles from './ProjectsListHeader.styles';
import { ProjectsSearchInput } from './ProjectsSearchInput';
import { definedTranslation } from '../../../../../i18n';

interface ProjectsListHeaderProps extends StackProps {
  projectsCount?: number;
  searchText?: string;
  onSearchTextChange?(value: string): void;
  intl: IntlShape;
}

export const ProjectsListHeader: FC<ProjectsListHeaderProps> = (props) => {
  const { projectsCount, searchText, onSearchTextChange, intl, ...stackProps } =
    props;

  const [searchMode, setSearchMode] = useState(false);

  const onSearchButtonClick = useCallback(() => {
    setSearchMode(true);
  }, []);

  return (
    <Stack direction="row" sx={styles.root} {...stackProps}>
      {!searchMode && (
        <Stack direction="row" sx={styles.buttonsContainer}>
          <Stack direction="row" sx={styles.titleContainer}>
            <Typography variant="body" fontWeight="700" component="p">
              {intl?.formatMessage(definedTranslation.allProjectsHeader) ||
                'All Projects'}
            </Typography>
            <ProjectsCountLabel count={projectsCount ?? 0} />
          </Stack>
          <IconButton
            iconName="search"
            color="secondary"
            onClick={onSearchButtonClick}
            size="large"
            dense
          />
        </Stack>
      )}
      {searchMode && (
        // @ts-expect-error // TODO: fix types
        <ProjectsSearchInput
          onInputChange={onSearchTextChange}
          value={searchText}
        />
      )}
    </Stack>
  );
};
